import { createContext, useContext } from 'react';

export interface HoaDonMuaHangTrongNuocSearchContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  ngayCt: string | undefined;
  setNgayCt: (value: string | undefined) => void;
  isImportDialogOpen: boolean;
  openImportDialog: () => void;
  closeImportDialog: () => void;
  transactionOptions: { value: string; label: string }[];
}

export const HoaDonMuaHangTrongNuocSearchContext = createContext<HoaDonMuaHangTrongNuocSearchContextValue | null>(null);

export function useHoaDonMuaHangTrongNuocSearchContext() {
  const context = useContext(HoaDonMuaHangTrongNuocSearchContext);

  if (!context) {
    throw new Error('useHoaDonMuaHangTrongNuocSearchContext must be used within HoaDonMuaHangTrongNuocSearchProvider');
  }

  return context;
}
